import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
interface EmailGateProps {
  onSubmit: (email: string) => void;
  score: number;
  tier: string;
}
export function EmailGate({
  onSubmit,
  score,
  tier
}: EmailGateProps) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const normalisedEmail = email.toLowerCase().trim();
    if (!normalisedEmail || !normalisedEmail.includes('@') || !normalisedEmail.includes('.')) {
      setError(true);
      return;
    }
    setIsSubmitting(true);
    setError(false);
    try {
      await fetch('https://sprooce.app.n8n.cloud/webhook/ux-guide-lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // Optional security header
          // 'x-api-key': 'YOUR_SECRET_TOKEN'
        },
        body: JSON.stringify({
          email: normalisedEmail,
          score: score,
          tier: tier,
          source: 'ux-guide',
          submitted_at: new Date().toISOString()
        })
      });
    } catch (err) {
      console.error('Webhook error:', err);
      // Do NOT block user experience if webhook fails
    }
    onSubmit(normalisedEmail);
    setIsSubmitting(false);
  };
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem'
  }} data-id="element-31">
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-32">
        <h2 style={{
        fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
        lineHeight: '1.2'
      }} data-id="element-33">
          Enter your email to see your result and get the guide
        </h2>
        <p style={{
        fontSize: '1.25rem',
        fontStyle: 'italic'
      }} data-id="element-34">
          No Theory. Just the Words That Matter.
        </p>
      </div>

      <form onSubmit={handleSubmit} style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-35">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }} data-id="element-36">
          <Input type="email" placeholder="Email address" value={email} onChange={e => {
          setEmail(e.target.value);
          if (error) setError(false);
        }} error={error} autoFocus data-id="element-37" />

          {error && <p style={{
          fontSize: '0.875rem',
          color: '#ef4444'
        }} data-id="element-38">
              Please enter a valid email address.
            </p>}
        </div>

        <Button type="submit" fullWidth disabled={isSubmitting} data-id="element-39">
          {isSubmitting ? 'One moment...' : 'See my result and get the guide'}
        </Button>
      </form>
    </div>;
}